import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import { formatDate } from '../../../utils/dateFormat.js';
import './TemperatureCardList.css';

const tempClass = (temp) => {
  if (temp === null || temp === undefined) return '';
  if (temp >= 35) return 'temp-hot';
  if (temp >= 25) return 'temp-warm';
  if (temp >= 15) return 'temp-mild';
  return 'temp-cold';
};

const TemperatureCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const date = row.date ? formatDate(row.date.substring(0, 10)) : '—';

  return (
    <div className={`temp-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="temp-card-main">
        <div className={`temp-card-value ${tempClass(row.temperature)}`}>{row.temperature}°C</div>
        <div className="temp-card-area">{row.area || '—'}</div>
        <div className="temp-card-chevron">{expanded ? '▲' : '▼'}</div>
        <div className="temp-card-date">{date}</div>
      </div>

      {expanded && (
        <div className="temp-card-detail" onClick={e => e.stopPropagation()}>
          <div className="temp-card-detail-row">
            <span>{t('temperature')}</span><span>{row.temperature}°C</span>
          </div>
          <div className="temp-card-detail-row">
            <span>{t('date')}</span><span>{date}</span>
          </div>
          <div className="temp-card-detail-row">
            <span>{t('area')}</span><span>{row.area || '—'}</span>
          </div>
          <div className="temp-card-detail-row">
            <span>{t('who')}</span><span>{row.created_by || '—'}</span>
          </div>
          <div className="temp-card-detail-row">
            <span>{t('from')}</span><span>{row.phone || '—'}</span>
          </div>
          <div className="temp-card-actions">
            <DeleteButton
              collection="temperatures"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const TemperatureCardList = ({ data, onRefresh }) => {
  return (
    <div className="temp-card-list">
      {data && data.map(row => (
        <TemperatureCard key={row._id} row={row} onDeleted={onRefresh} />
      ))}
      {(!data || data.length === 0) && (
        <div className="temp-card-empty">—</div>
      )}
    </div>
  );
};

export default TemperatureCardList;
